/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext, useState } from "react";
import { I18nContext } from "../../context/I18nProvider";
import ObserverContext from "../../context/Observer";

import useScrollToTop from "../../hooks/useScrollToTop";
import useWindowWidth from "../../hooks/useWindowWidth";

import Translate from "../../i18n/Translate";
import api from "../../api/Api";

import FilterMobile from "../../components/SportPackages/FilterMobile";
import Filters from "../../components/SportPackages/Filters";
import Cards from "../../components/SportPackages/Cards";

const SportsPackages = () => {
  const [data, setData] = useState({
    loading: false,
    data: [],
    error: null,
  });

  const [packagesFiltered, setPackagesFiltered] = useState([]);

  const { setActualComponent } = useContext(I18nContext);

  const { setElementInview } = useContext(ObserverContext);

  const width = useWindowWidth();

  // Scroll to top
  useScrollToTop();

  // Detectamos el scroll del contenedor line
  const handleScroll = (e) => {
    e.preventDefault();

    const top = window.scrollY < 343;

    setElementInview(!top);
  };

  const getData = async () => {
    setData({
      ...data,
      loading: true,
      error: null,
    });

    try {
      const {data} = await api.packages.getAll();
      setData({
        data,
        loading: false,
      });
    } catch (error) {
      setData({
        loading: false,
        error,
      });
      console.log("error");
    }
  };

  // Seteamos el componente actual, para las traduccion de rutas
  useEffect(() => {
    setActualComponent("psports");
  }, [setActualComponent]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    getData();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <section className="sport">
      <div className="sport__image triangle right"></div>

      <div className="sport__content">
        {/* End Selects */}

        {/* Header */}
        <div className="sport__content__header">
          <p>
            <Translate langkey="psports.title" />
          </p>
          <h1>
            <Translate langkey="psports.bolder" />
          </h1>
        </div>
        {/* End Header */}

        {/* Description */}
        <div className="sport__content__text">
          <p>
            <Translate langkey="psports.copy" />
          </p>
        </div>
        {/* End Description */}
      </div>

      {/* Grid */}
      <div className="sport__container">
        {width < 992 ? (
          <FilterMobile
            setPackagesFiltered={setPackagesFiltered}
            data={data.data}
          />
        ) : (
          <Filters setPackagesFiltered={setPackagesFiltered} loading={data.loading} data={data.data} />
        )}
        <div className="sport__grid">
          {packagesFiltered.length ? (
            packagesFiltered?.map((card, index) => (
              <Cards key={index} index={index} card={card} />
            ))
          ) : (
            <p>No hay resultados...</p>
          )}
        </div>
        {/* End Grid */}
      </div>
    </section>
  );
};

export default SportsPackages;
